// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	$w("#vectorImage1").onClick(()=>{

		if( $w("#section6").collapsed ) {
		$w("#section6").expand();
		}
		else {
		$w("#section6").collapse();
		}

	});

});